import { useTranslation } from 'react-i18next';

/** Full-viewport loading screen. Used by Suspense fallbacks. */
export function LoadingScreen() {
  const { t } = useTranslation('common');
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <div className="relative w-14 h-14">
        <div className="absolute inset-0 rounded-full border-2 border-pink-200" />
        <div className="absolute inset-0 rounded-full border-t-2 border-primary animate-spin" />
      </div>
      <p className="text-sm text-muted-foreground">{t('splash.loading')}</p>
    </div>
  );
}
